import { Component, OnInit } from '@angular/core';
import { SimpleModalService } from "ngx-simple-modal";
import { FinanceiroService } from "src/app/services/actions/financeiro.service";
import { UserService } from "src/app/services/user.service";
import { ModalCashBackComponent } from '../../helpers/modal-cash-back/modal-cash-back.component';
import CASHBACKS from '../../../enums/cash-backs'

@Component({
	selector: 'app-cash-back',
	templateUrl: './cash-back.component.html',
	styleUrls: ['./cash-back.component.scss']
})
export class CashBackComponent implements OnInit {

	dataCashBack
	payments
	totalPayments = 0
	nextTotal = 0
	nextTenSteps = []
	nextTenNumberAtend = []
	valorCashBachConsulta = 1.00
	showZero = true
	tableCash = []

	constructor(
		private financeiroService: FinanceiroService,
		private userService: UserService,
		private DefaultModal: SimpleModalService,
	) { }

	ngOnInit() {
		this.getPsiCashBack()
	}

	getPsiCashBack() {
		this.financeiroService
			.getPsiCahsBack(this.userService.getId())
			.subscribe(
				(res: any) => {
					this.dataCashBack = res.psiCashBackInfo[0]
					this.payments = res.payments
					if (this.dataCashBack && this.payments.length > 0) {
						this.showZero = false;
						this.getTotalPayments()
						this.mountPaymentSteps()
						this.getNextTotalPayments()
						return
					}
					this.mountZeroSteps()
					
				},
				(err) => {
					console.log(err)
				}
			);
	}

	mountZeroSteps() {
		const tenPaym = CASHBACKS.slice(0, 10);
		let total = 0
		tenPaym.forEach((numConsultas, index) => {
			const cashValue = (numConsultas * this.valorCashBachConsulta) - total
			total += cashValue
			this.tableCash.push({
				numConsultas,
				valor: cashValue,
				steps: tenPaym[index - 1] ? numConsultas - tenPaym[index - 1] : 0,
				total,
				nextStep: index === 0,
				payed: false
			})
		})
	}

	mountPaymentSteps() {
		const stepAtual = this.dataCashBack.numberToReceive
		const nextStep = this.dataCashBack.nextStep
		const listConsultasIndex = CASHBACKS.indexOf(stepAtual)
		const moreThenFivePayments = listConsultasIndex > 3
		let tenPaym = CASHBACKS.slice(0, 10)
		let total = 0

		if (!moreThenFivePayments) {
			tenPaym.forEach((numConsultas, index) => {
				const cashValue = (numConsultas * this.valorCashBachConsulta) - total
				const payed = CASHBACKS.indexOf(nextStep) > CASHBACKS.indexOf(numConsultas)
				total += cashValue
				this.tableCash.push({
					numConsultas,
					valor: cashValue,
					steps: tenPaym[index - 1] ? numConsultas - tenPaym[index - 1] : 0,
					payed,
					total,
					nextStep: nextStep === numConsultas,
				})
			})
		} else {
			const findIndex = CASHBACKS.indexOf(CASHBACKS[CASHBACKS.indexOf(CASHBACKS[listConsultasIndex]) - 3])
			let tenPaym = CASHBACKS.slice(findIndex, findIndex + 13)
			tenPaym.forEach((numConsultas, index) => {
				const cashValue = (numConsultas * this.valorCashBachConsulta) - total
				const payed = CASHBACKS.indexOf(nextStep) > CASHBACKS.indexOf(numConsultas)
				total += cashValue
				this.tableCash.push({
					numConsultas,
					valor: cashValue,
					steps: tenPaym[index - 1] ? numConsultas - tenPaym[index - 1] : 0,
					payed,
					total,
					nextStep: nextStep === numConsultas,
				})
			})
		}
	}

	getNextTotalPayments() {
		this.nextTotal = this.tableCash.find(d => d.nextStep).valor
	}

	getTotalPayments() {
		this.payments.forEach(payment => this.totalPayments += payment.value);
	}

	modalTableCashBack () {
		this.DefaultModal.addModal(ModalCashBackComponent)
	}

}
